<template>
    <v-layout>
        <v-flex>
            <v-card>
                <v-card-title>
                    <h3 class="headline mb-0 admin-header">Infrastructure</h3>
                    <v-btn text icon color="grey lighten-1" @click="refresh(pagination)"><v-icon>fas fa-sync</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                    <v-layout wrap>
                        <span class="subheading"><b>Filters:</b></span>
                        <v-icon v-if="showFilters" @click="showFilters = !showFilters">fal fa-chevron-up</v-icon>
                        <v-icon v-if="!showFilters" @click="showFilters = !showFilters">fal fa-chevron-down</v-icon>
                    </v-layout>
                        <v-form v-model="valid" v-if="showFilters" @submit.prevent>
                    <v-layout wrap>
                        <v-flex xs11>
                            <v-layout wrap>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Id" v-model="id" :rules="[rules.numeric]"></v-text-field>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-autocomplete
                                    v-model="orgId"
                                    :items="organizations"
                                    label="Organization"
                                        item-text="text"
                                        item-value="value">
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-select label="Deleted" v-model="deleted" :items="deletedItems"></v-select>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-select label="Enabled" v-model="enabled" :items="enabledItems"></v-select>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Type" v-model="type"></v-text-field>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Name" v-model="name"></v-text-field>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Description" v-model="description"></v-text-field>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Host" v-model="host"></v-text-field>
                                </v-flex>
                                <v-flex xs2 ml-4>
                                    <v-text-field label="Cca Id" v-model="ccaId" :rules="[rules.numeric]"></v-text-field>
                                </v-flex>
                                <!-- <v-flex xs2 ml-4>
                                    <v-text-field label="Conn Info" v-model="connInfo"></v-text-field>
                                </v-flex> -->
                            </v-layout>
                        </v-flex>
                        <v-flex xs1>
                            <button onsubmit="false" class="btn btn-primary" @click="applyFilters" :disabled="!valid">Apply</button>
                            <button onsubmit="false" class="btn btn-default" @click="resetFilters">Reset</button>
                        </v-flex>
                    </v-layout>
                        </v-form>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-data-table
                              :items="systems.content"
                              :loading="loading"
                              :headers="headers"
                              :options.sync="pagination"
                              :footer-props="{'items-per-page-options': [5, 10, 15, 20, 50, 100]}"
                              :server-items-length="totalItems"
                              class="infrastructureTable elevation-1"
                            >
                              <template v-slot:item.name="{item}">
                                  <td>
                                      <router-link to="" @click.native="editItem(item)">{{item.name}}</router-link>
                                  </td>
                              </template>
                              <template v-slot:item.deleted="{item}">
                                  <td>{{item.deleted ? 'yes' : 'no'}}</td>
                              </template>
                              <template v-slot:item.pollEnabled="{item}">
                                  <td>{{item.pollEnabled ? 'yes' : 'no'}}</td>
                              </template>
                              <template v-slot:item.updatedDate="{item}">
                                  <td>{{formatDateTime(item.updatedDate)}}</td>
                              </template>
                              <template v-slot:item.actions="{item}">
                                  <td class="actions">
                                      <v-btn
                                        text
                                        icon
                                        @click="editItem(item)"
                                        style="height: 0px; width: 0px; padding-right:2px;"
                                      >
                                          <v-icon v-if="isSUPro" color="grey lighten-1" style="font-size: 18px;" >fas fa-pencil</v-icon>
                                          <v-icon v-else color="grey lighten-1" style="font-size: 18px;" >fas fa-info-circle</v-icon>
                                      </v-btn>
                                  </td>
                              </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
            <v-dialog v-model="showEditSystemDialog" max-width="600px">
                <v-card>
                    <v-card-title>
                    <span class="headline">Infrastructure</span>
                    </v-card-title>

                    <v-card-text>
                        <v-form v-model="validSystem" @submit.prevent>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs9 class="subheading">
                                   Id: {{editedItem.id}} OrgId: {{editedItem.org.id}} ({{editedItem.org.name}}) <br/>
                                   Type: {{editedItem.type.code}} ({{editedItem.type.description}})
                                </v-flex>
                                <v-flex xs3>
                                    <v-text-field v-model="editedItem.ccaId" label="CcaId"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.name" :rules="[rules.required]" label="Name"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.description" label="Description"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.host" :rules="[rules.required]" label="Host Address"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.username" label="Username"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field v-model="editedItem.password" label="Password" type="password"></v-text-field>
                                </v-flex>
                                <v-flex xs6 sm3 md3>
                                    <v-checkbox v-model="editedItem.deleted" label="Deleted"></v-checkbox>
                                </v-flex>
                                <v-flex xs6 sm3 md3>
                                    <v-checkbox v-model="editedItem.pollEnabled" label="Enabled"></v-checkbox>
                                </v-flex>
                                <v-flex xs12 class="pa-0 ma-0">
                                    <span>Conn Info</span>
                                    <nv-pair v-if="showEditSystemDialog"
                                        :input="editedItem.connInfo"
                                        :captureChanges="true" 
                                        :hideButtons="true"
                                        @onChange="onConnInfoChange"></nv-pair>

                                    <!-- <v-textarea v-model="editedItem.connInfo" label="Conn Info"></v-textarea> -->
                                </v-flex>
                            </v-layout>
                        </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn class="mr-4" color="primary" outlined rounded  @click.native="close">{{isSUPro ? 'Cancel' : 'Close'}}</v-btn>
                        <v-btn color="primary" rounded  v-if="isSUPro" :disabled="!validSystem" @click.native="save">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-flex>
    </v-layout>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
import Utility from './utility'
import NVPair from '../Common/NVPair.vue'
export default {
    components: {
        'nv-pair': NVPair
    },
    computed: {
        ...mapGetters('user', {
            organizations: 'getOrganizationsTextValue',
            isSUPro: 'isSUPro'
        }),
        ...mapGetters('menus', {
          findRouteTitle: 'findRouteTitle'
        }),
        routeTitle: {
          get() {
            return this.findRouteTitle(this.$route.name) || this.title
          }
        }
    },
    data() {
        return {
            systems: {
                "content": [],
                "totalElements": 0
            },
            loading: false,
            search: '',
            pagination : {
                    descending: true,
                    page: 1,
                    rowsPerPage: 10, // -1 for All",
                    itemsPerPage: 10,
                    sortBy: ["updatedDate"]
            },
            totalItems: 0,
            headers: [
                {text: 'Id', align: 'left', sortable: true, value: 'id'},
                {text: 'Org Id', align: 'left', sortable: true, value: 'org.id'},
                {text: 'Org Name', align: 'left', sortable: true, value: 'org.name'},
                {text: 'Type', align: 'left', sortable: true, value: 'type.code'},
                {text: 'Name', align: 'left', sortable: true, value: 'name'},
                {text: 'Description', align: 'left', sortable: true, value: 'description'},
                {text: 'Host', align: 'left', sortable: true, value: 'host'},
                {text: 'Cca Id', align: 'left', sortable: true, value: 'ccaId'},
                {text: 'Deleted', align: 'left', sortable: true, value: 'deleted'},
                {text: 'Enabled', align: 'left', sortable: true, value: 'pollEnabled'},
                {text: 'Updated Date', align: 'left', sortable: true, value: 'updatedDate'},
                {text: 'Actions', align: 'left', sortable: false, value: 'actions'}
//                {text: 'Configs', align: 'left', sortable: true, value: 'connInfo'}
            ],
            orgId: null,
            deleted: null,
            enabled: null,
            name: null,
            description: null,
            host: null,
            type: null,
            connInfo: null,
            id: null,
            ccaId: null,
            deletedItems:[
                {text: 'All', value: null},
                {text: 'Deleted only', value: true},
                {text: 'Non-deleted only', value: false}
            ],
            enabledItems:[
                {text: 'All', value: null},
                {text: 'Enabled only', value: true},
                {text: 'Disabled only', value: false}
            ],
            rules: {
                required: value => !!value || 'Required.',
                numeric: value => !value || Number.isInteger(+value) || 'Invalid format'
            },
            valid: false,
            showFilters: true,
            validSystem: false,
            showEditSystemDialog: false,
            originalItem: null,
            editedItem: {
                id: -1,
                name: '',
                description: '',
                host: '',
                username: '',
                password: '',
                connInfo: '',
                deleted: false,
                pollEnabled: false,
                ccaId: null,
                org: {id: '', name: ''},
                type: {code: '', name: '', description: ''}
            },
            defaultItem: {
                id: -1,
                name: '',
                description: '',
                host: '',
                username: '',
                password: '',
                connInfo: '',
                deleted: false,
                pollEnabled: false,
                ccaId: null,
                org: {id: '', name: ''},
                type: {code: '', name: '', description: ''}
            },
            originalPassword: null
        }
    },
    watch: {
        pagination: {
            async handler () {
                await this.refresh(this.pagination)
            }, deep: true
        }
    },
    methods: {
        async refresh(pagination) {

            const { page, itemsPerPage, sortBy, sortDesc } = pagination

            let sort = ""
            if (sortBy && sortBy.length) {
                sort = sortBy[0] + "," + (sortDesc && sortDesc.length && sortDesc[0] ? 'desc' : 'asc')
            }

            let id = this.id ? +this.id : this.id
            let ccaId = this.ccaId ? +this.ccaId : this.ccaId

            let filter = Utility.buildQueryString(['id', 'cca_id', 'org_id', 'deleted', 'enabled', 'name', 'description', 'host', 'type', 'conn_info'],
                              [id, ccaId, this.orgId, this.deleted, this.enabled, this.name, this.description, this.host, this.type, this.connInfo],
                              ['name', 'description', 'host', 'type', 'conn_info'])

            this.loading = true

            this.systems = await this.$store.dispatch('crossorg/getSystems',
                {filter, size: itemsPerPage || 10, page: page ? page - 1 : 0, sort})

            this.totalItems = this.systems.totalElements

            this.loading = false
        },
        formatDateTime(val) {
            return moment(val).isValid() ? moment(val).format('MM/DD/YYYY, h:mm:ss a') : val
        },
        async resetFilters() {
            this.orgId = null
            this.deleted = null
            this.enabled = null
            this.name = null
            this.description = null
            this.host = null
            this.type = null
            this.connInfo = null
            this.id = null
            this.ccaId = null

            await this.refresh(this.pagination)

        },
        async applyFilters() {
            await this.refresh(this.pagination)
        },
        async editItem (item) {
            this.originalItem = item
            this.originalPassword = item.password
            this.editedItem = Object.assign({}, item)
            this.showEditSystemDialog = true
        },
        close() {
            this.showEditSystemDialog = false
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.originalItem = null
                this.originalPassword = null
            }, 300)
        },
        async save () {
            await this.$store.dispatch("crossorg/updateSystem", {system: this.editedItem,
                                                patchObject: Utility.createPatchObject(this.originalItem, this.editedItem),
                                                pwd: (this.editedItem.password !== this.originalPassword)})
            this.close()

            await this.refresh(this.pagination)
        },
        onConnInfoChange (val) {
            this.editedItem.connInfo = val
        }
    }
}
</script>
